<script>
export default {
  props: {
    id: {
      type: [String, Number, undefined],
      required: false,
      default: null,
    },
    leagueId: {
      type: [String, Number],
      required: false,
    },
  },
  data() {
    return {
      record: null,
    }
  },
  mounted() {
    this.fetchRecord()
  },
  methods: {
    fetchRecord() {
      this.$axios
        .get(`leagues/${this.leagueId}/rewards/${this.id}`)
        .then((res) => {
          this.record = res.data
        })
    },
  },
}
</script>

<template>
  <table v-if="record != null" class="table table-nowrap mb-0">
    <tbody>
      <tr>
        <th scope="row" style="width: 400px;">نام</th>
        <td>{{ record.name }}</td>
      </tr>
      <tr>
        <th scope="row">توضیحات</th>
        <td>{{ record.des }}</td>
      </tr>
      <tr>
        <th scope="row">آیکن</th>
        <td><img :src="record.logoAdd" /></td>
      </tr>
      <tr>
        <th scope="row">از رتبه</th>
        <td>{{ record.startPos }}</td>
      </tr>
      <tr>
        <th scope="row">تا رتبه</th>
        <td>{{ record.endPos }}</td>
      </tr>
      <tr>
        <th scope="row">وضعیت</th>
        <td>
          <span
            class="px-2 rounded-lg"
            :class="{
              'badge-danger': record.isActive === 0,
              'badge-success': record.isActive === 1,
            }"
            >{{ record.isActive === 1 ? 'فعال' : 'غیر فعال' }}</span
          >
        </td>
      </tr>
      <tr>
        <th scope="row">جوایز</th>
        <td>
          <span class="d-block" v-for="(item, i) in record.details" :key="i">
            <span
              ><strong>نوع: </strong
              >{{ item.kind === 0 ? 'فیزیکی' : 'دیتا' }}</span
            >
            <br />
            <span class="mt-2"
              ><strong>نام: </strong>{{ item.rewardName }}</span
            >
            <br />
            <span class="mt-2"
              ><strong>تعداد: </strong
              >{{ item.myCount === -1 ? '' : item.myCount }}</span
            >
            <br />
            <hr style="border-style: dashed" class="border-primary" />
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>
